// libs
import React from 'react';
import cx from 'classnames';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { DlsFontVariants } from '@/constants/DLSTokens';
// styles
import styles from './GenericAvatar.module.scss';
const colors = [
    '#D8D9DA',
    '#FFEECC',
    '#FFDDCC',
    '#FFCCCC',
    '#F6F4EB',
    '#91C8E4',
    '#FFDBAA',
];
const GenericAvatar = (props) => {
    const colorIndex = props.name.length % colors.length;
    const bgColor = colors[colorIndex];
    return (React.createElement("div", { className: cx(styles.container, props.className), style: {
            backgroundColor: bgColor,
        } },
        React.createElement(Text, { variant: DlsFontVariants.header_H4 }, props.name.trim().charAt(0).toUpperCase())));
};
export default GenericAvatar;
